import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class SupportService {
  constructor(private http: HttpClient) {}
  // ton apis
  getDriverRequests(data) {
    return this.http.post(environment.apiUrl + "driver/support/all", data);
  }
   getUserRequests(data) {
    return this.http.post(environment.apiUrl + "user/support/all", data);
  }
}